import { t as translate, J as JS_PREFIX, C as CART_UPDATE_EVENT, a as CART_CLEAR_EVENT, P as PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT, b as CART_COUNT_UPDATE_EVENT } from './built-constants-439d5572.js';
import { g as getCart } from './built-ajax-api-4ab76389.js';
import { c as cartEventEmitter } from './built-cart-event-emitter-def8079a.js';
import './built-env-utils-ed419642.js';
import './built-config-a65ae98c.js';

const CART_QUANTITY_UPDATED_TEXT = translate("Cantidad Actualizada");
/**
 * Updates the "cart count" in the corner.
 * Establishes a closure to hold variables for initialization
 * @returns { ({count, clearUpdateText = false}: {count: number | string, clearUpdateText?: boolean}) => void }
 */


const _updateCartUI = () => {
  /** @type {NodeListOf<HTMLElement> | null} */
  let headerCartCountEls = null;
  /** @type {NodeListOf<HTMLElement> | null} */

  let headerCartCountUpdatedTextEls = null;
  return ({
    count,
    clearUpdateText = false
  }) => {
    let countChanged = false; // The element(s) that display cart count in the header

    headerCartCountEls = headerCartCountEls || document.querySelectorAll("." + JS_PREFIX + "MenuBar-cart-count"); // The elements that display contextual, visually hidden text to cart count, when updated

    headerCartCountUpdatedTextEls = headerCartCountUpdatedTextEls || document.querySelectorAll("." + JS_PREFIX + "MenuBar-cart-count-updated");
    headerCartCountEls.forEach(el => {
      var _el$textContent;

      if (((_el$textContent = el.textContent) == null ? void 0 : _el$textContent.trim()) !== String(count)) {
        countChanged = true;
      }
    });

    if (countChanged) {
      headerCartCountEls.forEach(el => {
        el.textContent = String(count);
      });
    }
    /**
     * If the count has changed since page load, set visually-hidden
     * text. If the event specifically flags clearing the count (e.g., upon
     * logout), don't set the text
     */


    if (!clearUpdateText && countChanged) {
      headerCartCountUpdatedTextEls.forEach(el => {
        var _el$textContent2;

        if (((_el$textContent2 = el.textContent) == null ? void 0 : _el$textContent2.trim()) === '') {
          el.textContent = CART_QUANTITY_UPDATED_TEXT + ", ";
        }
      });
    }
    /**
     * If the event specifically flags clearing the count (e.g., upon
     * logout), clear the visually-hidden text
     */


    if (clearUpdateText) {
      headerCartCountUpdatedTextEls.forEach(el => {
        el.textContent = '';
      });
    }
  };
};
/**
 * Initialize the module and export the updateCartUI function
 */


const updateCartUI = _updateCartUI();

// @ts-check
/**
 * @typedef { Omit<import('mitt').Emitter, 'emit'> & {emit: (type: string, count?:number) => void } } CartCountUpdateEmitter
 */

/**
 * Updates the header cart component (icon) count
 * @param { import('../cart').Cart | undefined } cart
 */

const updateCartCount = cart => {
  if (!cart) return;
  updateCartUI({
    count: cart.item_count
  });
};
/**
 * When an item has been added to cart via a product tile ATC, fetch cart and set cart count
 */


const handleProductTileATC = async () => {
  const cart = await getCart();
  updateCartCount(cart);
};
/**
 * Listens for a AJAX add to cart action, triggered by the Product Page buybox
 */


cartEventEmitter.on(CART_UPDATE_EVENT, updateCartCount);
/**
 * Listens for a AJAX clear action, triggered when a user logs out
 * @NOTE Another option is to call `handleProductTileATC` (maybe renaming it),
 * with the end result being the same. An additional cart request will be made,
 * but it might be a cleaner option.
 */

cartEventEmitter.on(CART_CLEAR_EVENT, () => updateCartUI({
  count: 0,
  clearUpdateText: true
}));
/**
 * Listens for a successful Product Tile cart to cart action
 */

cartEventEmitter.on(PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT, handleProductTileATC);
/**
 * Listens for an event that passes a new cart count to update in the header
 */

/** @type { CartCountUpdateEmitter } */

cartEventEmitter.on(CART_COUNT_UPDATE_EVENT, count => updateCartUI({
  count
}));
